/* eslint-disable eqeqeq */
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { AiOutlineAppstore } from "react-icons/ai";
import { BsArrowReturnLeft } from "react-icons/bs";
const Header = (props) => {
  const router = useHistory();
  return (
    <div className='header'>
      <div className='container'>
        <div className='child-header'>
          <div>
            <Link to='/service'>
              <AiOutlineAppstore size={25} />
            </Link>
          </div>
          <div className='header-title'>{props.title}</div>
          <div>
            {window.location.pathname !== "/" && (
              <span onClick={() => router.goBack()}>
                <BsArrowReturnLeft size={25} />
              </span>
            )}
          </div>
        </div>
        {/* {props.children} */}
      </div>
    </div>
  );
};
export default Header;
